import moment from 'moment';
import { Middleware } from 'redux';
import inspectorActions, {
	EInspectorActions,
	TInspectorActions,
} from './actions';
import inspectorConstants from './constants';
import inspectorSelectors from './selectors';
import { getAPINameForDocumentConfig, getDate } from './utils';
import { commonUtils } from 'redux/_common';
import { IStore } from 'redux/store';
import { jobActions } from 'redux/_core/job';
import { apiActions, apiUtils } from 'redux/_core/api';
import { EORB1RecordState } from 'redux/app/orb1/@types';
import { ISealLog } from 'redux/app/logs/@types';
import { orb1Actions } from 'redux/app/orb1';
import { EORB4RecordState } from 'redux/app/orb4/@types';
import orb4Actions from 'redux/app/orb4/actions';
import { crbActions } from 'redux/app/crb';
import { ECRBRecordState } from 'redux/app/crb/@types';
import { EGarbageRecordState } from 'redux/app/garbage-record/@types';
import { garbageRecordActions } from 'redux/app/garbage-record';
import { EGRB2State } from 'redux/app/grb2/@types';
import { grb2Actions } from 'redux/app/grb2';
import { EBFL1RecordState } from 'redux/app/bfl-1/@types';
import { bfl1Actions } from 'redux/app/bfl-1';
import { EBFL2RecordState } from 'redux/app/bfl-2/@types';
import { bfl2Actions } from 'redux/app/bfl-2';
import { EAnnex6RecordState } from 'redux/app/annex6/@types';
import { annex6Actions } from 'redux/app/annex6';
import { EBallastRecordState } from 'redux/app/ballast/@types';
import { ballastActions } from 'redux/app/ballast';
import { EAnnex6V2RecordState } from 'redux/app/annex6-v2/@types';
import { annex6V2Actions } from 'redux/app/annex6-v2';
import { historyActions } from 'redux/_core/history';
import { rootRoutes } from 'routes';

const { isValidUrlDateTimeString, isValidDateTimeFormat } =
	commonUtils;

const { apiRequest } = apiActions;

const inspectorMiddleware: Middleware<{}, IStore> = ({
	dispatch,
	getState,
}) => {
	return (next) => (action: TInspectorActions) => {
		switch (action.type) {
			case EInspectorActions.GET_LOGS: {
				next(action);
				const { filters, vesselId } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				const inspectorStore = inspectorSelectors._getStore(getState());

				let dateRange = inspectorSelectors.getDateRange(inspectorStore);
				let entry = inspectorSelectors.getEntryFilter(inspectorStore);

				let where: any = {};
				
				if (dateRange?.startDate && dateRange?.endDate) {
					// console.log('dateRange', dateRange);
					// let startDate = commonUtils
					//     .getUtcTime(dateRange.startDate)
					//     .format('yyyy-MM-DD');

					// let endDate = commonUtils
					//     .getUtcTime(dateRange.endDate)
					//     .format('yyyy-MM-DD');

					let startDate = moment(dateRange.startDate).format(
						'yyyy-MM-DD'
					);
					let endDate = moment(dateRange.endDate).format(
						'yyyy-MM-DD'
					);

					startDate = commonUtils.getStartOfDay(startDate);
					endDate = commonUtils.getEndOfDay(endDate);
					where = {
						createdAt: {
							$gte: startDate,
							$lte: endDate,
						},
					};
				} else {
					// let startDate = moment.utc().subtract(30, 'days');
					// let endDate = moment.utc().add(1, 'days');

					let startDate = moment()
						.subtract(30, 'days')
						.format('yyyy-MM-DD');
					let endDate = moment().add(1, 'days').format('yyyy-MM-DD');

					startDate = commonUtils.getStartOfDay(startDate);
					endDate = commonUtils.getEndOfDay(endDate);
					where = {
						createdAt: {
							$gte: startDate,
							$lte: endDate,
						},
					};
				}

				if (entry && entry.id) {
					if (where) {
						where['code'] = entry.id;
					} else {
						where = {
							code: entry.id,
						};
					}
				} else {
					dispatch(
						job.error({
							message: 'Please select a entry.',
							notification: {},
						})
					);
					dispatch(job.idle({}));
					return;
				}
				
				const count = inspectorSelectors.getPagination(inspectorStore)?.count;
				
				where = {
					...where,
					vesselId,
					createdAt: null,
					selectedDate: where.createdAt,
					isApprove: true,
					skip: 0,
					limit: count ?? 100,
				};
				dispatch(
					apiRequest({
						feature: action.type,
						method: 'GET',
						url: `${commonUtils.getAPIBaseUrl()}/api/logs`,
						queryParams: where,
						preExecute() {
							dispatch(
								job.active({
									message: 'Fetching logs!',
									notification: {},
								})
							);
						},
						postExecute: {
							onSuccess({ data }) {
								dispatch(
									job.success({
										message: 'Logs fetched successfully',
										notification: {},
									})
								);
								// const logsMap: any = {};
								// const logs = (data as any[]).reduce((prev, curr) => {
								//     const d = getDate(curr, entry?.type);
								//     console.log(d);
								//     if (d) {
								//         const key = moment(d).format('DD-MM-YY');
								//         const idx = logsMap[key];
								//         if ((idx || idx === 0) && (prev[idx] && Array.isArray(prev[idx]))) {
								//             prev[idx].push(curr);
								//         } else {
								//             prev.push([curr]);
								//             logsMap[key] = prev.length - 1;
								//         }
								//     }
								//     return prev;
								// }, []);
								// logs.sort((a: any, b: any) => moment(getDate(a?.[0], entry?.type)).diff(getDate(b?.[0], entry?.type)));
								// dispatch(inspectorActions.document.setLogs(
								//     logs
								// ));
								let logs = (data as any[])?.sort((a: any, b: any) =>
									moment
										.utc(getDate(a, entry?.type))
										.diff(getDate(b, entry?.type))
								);
								if (entry && entry.type === 'LOG') {
									logs = logs.reduce((prev: any, value: any) => {
										if (prev.length === 0) {
											prev.push(value);	
										} else {
											const currLogSelectedDate =
												value.selectedDate;
											const prevLogSelectedDate =
												prev[prev.length - 1]
													.selectedDate;
											const intlLineRcrd =
												value.intlDateLineRecord;
											const prevIntlLineRecrd =
												prev[prev.length - 1]
													.intlDateLineRecord;
											if (
												currLogSelectedDate &&
												prevLogSelectedDate &&
												currLogSelectedDate !==
												prevLogSelectedDate
											) {
												prev.push(value);
											}

											if (
												currLogSelectedDate &&
												prevLogSelectedDate &&
												currLogSelectedDate ===
												prevLogSelectedDate &&
												intlLineRcrd !==
												prevIntlLineRecrd
											) {
												prev.push(value);
											}
										}
										return prev;
									}, []);
								}
								dispatch(
									inspectorActions.document.setLogs(logs)
								);
								// call print-templates
								// if (entry?.id) {
								//     dispatch(
								//         inspectorActions.commands.getLogPrintTemplate(
								//             entry.id,
								//             action.type
								//         )
								//     );
								// }
							},
							onError(error) {
								dispatch(
									job.error({
										message:
											apiUtils.getResponseStatusMessageForError(
												error
											),
									})
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					})
				);
				break;
			}
			case EInspectorActions.GET_CHECKLISTS: {
				next(action);
				const { filters } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				const inspectorStore = inspectorSelectors._getStore(getState());

				let dateRange = inspectorSelectors.getDateRange(inspectorStore);
				let entry = inspectorSelectors.getEntryFilter(inspectorStore);

				let where: any = {};
				
				if (dateRange?.startDate && dateRange?.endDate) {
					// console.log('dateRange', dateRange);
					// let startDate = commonUtils
					//     .getUtcTime(dateRange.startDate)
					//     .format('yyyy-MM-DD');

					// let endDate = commonUtils
					//     .getUtcTime(dateRange.endDate)
					//     .format('yyyy-MM-DD');

					let startDate = moment(dateRange.startDate).format(
						'yyyy-MM-DD'
					);
					let endDate = moment(dateRange.endDate).format(
						'yyyy-MM-DD'
					);

					startDate = commonUtils.getStartOfDay(startDate);
					endDate = commonUtils.getEndOfDay(endDate);
					where = {
						createdAt: {
							$gte: startDate,
							$lte: endDate,
						},
					};
				} else {
					// let startDate = moment.utc().subtract(30, 'days');
					// let endDate = moment.utc().add(1, 'days');

					let startDate = moment()
						.subtract(30, 'days')
						.format('yyyy-MM-DD');
					let endDate = moment().add(1, 'days').format('yyyy-MM-DD');

					startDate = commonUtils.getStartOfDay(startDate);
					endDate = commonUtils.getEndOfDay(endDate);
					where = {
						createdAt: {
							$gte: startDate,
							$lte: endDate,
						},
					};
				}

				if (entry && entry.id) {
					if (where) {
						where['code'] = [entry.id];
					} else {
						where = {
							code: [entry.id],
						};
					}
				} else {
					dispatch(
						job.error({
							message: 'Please select a entry.',
							notification: {},
						})
					);
					dispatch(job.idle({}));
					return;
				}
				where = {
					...where,
					isApprove: {
						eq: true,
					},
				};
				const filter: any = {
					...filters,
					selectedDate: filters.createdAt,
					createdAt: null,
				};
				
				const count =
					inspectorSelectors.getPagination(inspectorStore)?.count;
				if (count) {
					filter['limit'] = count;
				}
				dispatch(
					apiRequest({
						feature: action.type,
						method: 'GET',
						url: `${commonUtils.getAPIBaseUrl()}/api/checklists`,
						queryParams: {
							...filter,
							skip:0,
							limit:100,
							showAllFields: true,
						},
						preExecute() {
							dispatch(
								job.active({
									message: 'Fetching checklists!',
									notification: {},
								})
							);
						},
						postExecute: {
							onSuccess({ data }) {
								dispatch(
									job.success({
										message: 'Checklists fetched successfully',
										notification: {},
									})
								);
                                let checklists = (data as any[]).sort((a, b) =>
									moment
										.utc(getDate(a, entry?.type))
										.diff(getDate(b, entry?.type))
								);
								dispatch(
									inspectorActions.document.setLogs(checklists)
								);
							},
							onError(error) {
								dispatch(
									job.error({
										message:
											apiUtils.getResponseStatusMessageForError(
												error
											),
									})
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					})
				);
				break;
			}

			case EInspectorActions.GET_LOGS_COUNT: {
				next(action);
				const { vesselId } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				const inspectorStore = inspectorSelectors._getStore(getState());

				let dateRange = inspectorSelectors.getDateRange(inspectorStore);
				let entry = inspectorSelectors.getEntryFilter(inspectorStore);

				const isLog = entry?.type === "LOG";

				let where: any = {};

				if (dateRange?.startDate && dateRange?.endDate) {
					// let startDate = commonUtils
					//     .getUtcTime(dateRange.startDate)
					//     .format('yyyy-MM-DD');
					// let endDate = commonUtils
					//     .getUtcTime(dateRange.endDate)
					//     .format('yyyy-MM-DD');

					let startDate = moment(dateRange.startDate).format(
						'yyyy-MM-DD'
					);
					let endDate = moment(dateRange.endDate).format(
						'yyyy-MM-DD'
					);

					startDate = commonUtils.getStartOfDay(startDate);
					endDate = commonUtils.getEndOfDay(endDate);
					where = {
						createdAt: {
							$gte: startDate,
							$lte: endDate,
						},
					};
				} else {
					// let startDate = moment.utc().subtract(30, 'days');
					// let endDate = moment.utc().add(1, 'days');

					let startDate = moment().subtract(30, 'days');

					let endDate = moment().add(1, 'days');

					dispatch(
						inspectorActions.document.setDateRange({
							endDate: endDate.toDate(),
							startDate: startDate.toDate(),
						})
					);

					let startDateFinal = startDate.format('yyyy-MM-DD');
					startDateFinal = commonUtils.getStartOfDay(startDateFinal);

					let endDateFinal = endDate.format('yyyy-MM-DD');
					endDateFinal = commonUtils.getEndOfDay(endDateFinal);

					where = {
						createdAt: {
							$gte: startDateFinal,
							$lte: endDateFinal,
						},
					};
				}

				let modelName = "";
				if (entry && entry.id) {
					if (where) {
						if (isLog) {
							where['code'] = entry.id;
							modelName = "logs";
						} else {
							where['code'] = entry.id;
							modelName = "permitLogs";
						}
					} else {
						if (isLog) {
							where = {
								code: entry.id,
							};
							modelName = "logs";
						} else {
							where = {
								code: entry.id,
							};
							modelName = "permitLogs";
						}
					}
				}
				where = {
					...where,
					vesselId,
					isApprove: true,
				};
				// if entry type is marpol and id is ORB1 then set it's date range seperately.
				if (entry?.type === 'MARPOL' && entry?.id) {
					console.log('calling orb1 set filter');
					let marpolDateRange = {
						startDate: commonUtils.getStartOfDay(
							moment(dateRange.startDate).format('YYYY-MM-DD')
						),
						endDate: commonUtils.getEndOfDay(
							moment(dateRange.endDate).format('YYYY-MM-DD')
						),
						state: '',
						// sortOrder: 'asc',
						// shownRecords: 'ALL',
					};

					switch (entry.id) {
						case 'ORB1':
							marpolDateRange['state'] =
								EORB1RecordState.APPROVED;
							dispatch(
								orb1Actions.document.setFilter(marpolDateRange)
							);
							dispatch(
								orb1Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'ORB4':
							marpolDateRange['state'] =
								EORB4RecordState.APPROVED;
							dispatch(
								orb4Actions.document.setFilter(marpolDateRange)
							);
							dispatch(
								orb4Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'CRB':
							marpolDateRange['state'] =
								ECRBRecordState.APPROVED;
							dispatch(
								crbActions.document.setFilter(marpolDateRange)
							);
							dispatch(
								crbActions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'GRB1':
							marpolDateRange['state'] =
								EGarbageRecordState.APPROVED;
							dispatch(
								garbageRecordActions.document.filterSet(marpolDateRange)
							);
							dispatch(
								garbageRecordActions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'GRB2':
							marpolDateRange['state'] = EGRB2State.APPROVED;
							dispatch(
								grb2Actions.document.filterSet(marpolDateRange)
							);
							dispatch(
								grb2Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'BFL1':
							marpolDateRange['state'] =
								EBFL1RecordState.APPROVED;
							dispatch(
								bfl1Actions.document.setFilter(marpolDateRange)
							);
							dispatch(
								bfl1Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'BFL2':
							marpolDateRange['state'] =
								EBFL2RecordState.APPROVED;
							dispatch(
								bfl2Actions.document.setFilter(marpolDateRange)
							);
							dispatch(
								bfl2Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'ANNEX6':
							marpolDateRange['state'] =
								EAnnex6RecordState.APPROVED;
							dispatch(
								annex6Actions.document.setFilter(
									marpolDateRange
								)
							);
							dispatch(
								annex6Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'BALLAST':
							marpolDateRange['state'] =
								EBallastRecordState.APPROVED;
							dispatch(
								ballastActions.document.setFilter({
									...marpolDateRange,
								})
							);
							dispatch(
								ballastActions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;
						case 'BALLAST_TANK_OPERATIONS': {
							// No need to setFilter for ballast.
							dispatch(
								ballastActions.commands.tableLogsLoad({
									...marpolDateRange,
									shownRecords: "ALL",
                                    sortOrder: 'asc',
									vesselId,
								})
							);
							break;
						}
						case 'ANNEX6V2':
							marpolDateRange['state'] =
								EAnnex6V2RecordState.APPROVED;
							dispatch(
								annex6V2Actions.document.setFilter(marpolDateRange)
							);
							dispatch(
								annex6V2Actions.commands.historyLoad({
									...marpolDateRange,
									sortOrder: 'asc',
									shownRecords: 'ALL',
									vesselId,
								})
							);
							break;

						default:
							break;
					}
					return;
				}
				dispatch(
					apiRequest({
						feature: action.type,
						method: 'GET',
						url: `${commonUtils.getAPIBaseUrl()}/api/count`,
						queryParams: {
							modelName: modelName,
							filter: {
								selector: {
									$and: [
            							...Object.keys(where || {}).map(key => ({ [key]: where[key] }))
									]
								}
							},
						},

						preExecute() {
							// dispatch(inspectorActions.document.setSelectedLog({}));
						},
						postExecute: {
							onSuccess({ data }) {
								const { count } = data;
								typeof count === 'number' &&
									dispatch(
										inspectorActions.document.setLogsCount(
											count
										)
									);
								if(isLog){
									dispatch(inspectorActions.commands.getLogs(where, vesselId));
								} else {
									dispatch(inspectorActions.commands.getChecklists(where));
								}
							},
							onError(error) {
								dispatch(
									job.error({
										message:
											apiUtils.getResponseStatusMessageForError(
												error
											),
									})
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					})
				);

				break;
			}
			case EInspectorActions.GET_LOG_CONFIG: {
				next(action);
				const { code, documentType, vesselId } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);

				// logsUrl would return undefined for engine, deck, etc.
				// only PERMIT, CHECKLIST, LOG would return their respective URLS
				const logsUrl = getAPINameForDocumentConfig(
					documentType as any
				);
				
				let queryParams: any = { code: code, vesselId };
				if (logsUrl) {
					if (
						logsUrl === 'permit-configs' ||
						logsUrl === 'log-configs'
					) {
						queryParams = {
							code: code,
							vesselId,
						};
					}
				}
				if (code && logsUrl) {
					dispatch(
						apiActions.apiRequest({
							feature: action.type,
							method: 'GET',
							url: `${commonUtils.getAPIBaseUrl()}/api/logs`,
							queryParams: queryParams,
							postExecute: {
								onSuccess({ data: taskConfig }) {
									setTimeout(() => {
										dispatch(
											inspectorActions.document.setLogConfig(
												taskConfig
											)
										);
										dispatch(job.idle({}));
									}, 500);
								},
								onError(error) {
									dispatch(
										job.error({
											message:
												apiUtils.getResponseStatusMessageForError(
													error
												),
											notification: {},
										})
									);
									dispatch(job.idle({}));
								},
							},
						})
					);
				} else {
					console.log('no code provided!');
				}
				break;
			}
			case EInspectorActions.GET_LOG_PRINT_TEMPLATE: {
				next(action);

				const { code, vesselId, recordConfigVersion } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);

				if (code) {
					dispatch(
						apiActions.apiRequest({
							feature: action.type,
							method: 'GET',
							url: `${commonUtils.getAPIBaseUrl()}/api/printTemplates`,
							queryParams: {
								vesselId,
								code,
								recordConfigVersion,
							},
							preExecute() {
								dispatch(
									job.active({
										message: 'Loading PrintTemplate',
									})
								);
							},
							postExecute: {
								onSuccess({ data: printTemplate }) {
									setTimeout(() => {
										if (printTemplate) {
											dispatch(
												inspectorActions.document.setLogPrintTemplate(
													printTemplate
												)
											);
										}
										dispatch(job.idle({}));
									}, 500);
								},
								onError(error) {
									dispatch(
										job.error({
											message:
												apiUtils.getResponseStatusMessageForError(
													error
												),
											notification: {},
										})
									);
									dispatch(job.idle({}));
								},
							},
						})
					);
				} else {
					console.log('no code provided!');
				}
				break;
			}
			case EInspectorActions.GET_CHECKLIST_PRINT_TEMPLATE: {
				next(action);

				const { code, vesselId } = action.payload;
				const inspectorStore = inspectorSelectors._getStore(getState());
				const entry = inspectorSelectors.getEntryFilter(inspectorStore);
				const selectedLog =
					inspectorSelectors.getSelectedLog(inspectorStore);

				if (
					selectedLog?.logPrintTemplate &&
					(entry?.id !== "engineLogConfig" && selectedLog?.logPrintTemplate?.typeOfLogs ===
						entry?.typeOfLogs)
				) {
					return;
				}
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				// Only for Engine Log Config
				let recordConfigVersion =
					selectedLog?.log?.[0]?.versionInfo?.config || undefined;

				if (code) {
					dispatch(
						apiActions.apiRequest({
							feature: action.type,
							method: 'GET',
							url: `${commonUtils.getAPIBaseUrl()}/api/printTemplates`,
							queryParams: {
								vesselId,
								code,
								recordConfigVersion,
							},
							preExecute() {
								dispatch(
									job.active({
										message: 'Loading PrintTemplate',
									})
								);
							},
							postExecute: {
								onSuccess({ data: printTemplate }) {
									setTimeout(() => {
										if (printTemplate) {
											dispatch(
												inspectorActions.document.setLogPrintTemplate(
													printTemplate
												)
											);
										}
										dispatch(job.idle({}));
									}, 500);
								},
								onError(error) {
									dispatch(
										job.error({
											message:
												apiUtils.getResponseStatusMessageForError(
													error
												),
											notification: {},
										})
									);
									dispatch(job.idle({}));
								},
							},
						})
					);
				} else {
					console.log('no code provided!');
				}
				break;
			}

			case EInspectorActions.GET_ALL_LOGS_OF_A_DAY: {
				next(action);

				const { selectedDate, logCode, intlDateLineRecord, vesselId } =
					action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				let url = '/logs';
				if (selectedDate && logCode) {
					let where: any = {
						isApprove: true,
						selectedDate,
						code: logCode,
						vesselId,
					};
					if (intlDateLineRecord === true) {
						where.intlDateLineRecord = true;
					}
					// if code is deckLogConfig then get the associatedDayLog for this selectedDate

					dispatch(
						apiActions.apiRequest({
							feature: action.type,
							method: 'GET',
							url: `${commonUtils.getAPIBaseUrl()}/api/logs`,
							queryParams: where,
							preExecute() {
								dispatch(job.active({}));
							},
							postExecute: {
								onSuccess({ data: groupedTaskData }) {
									dispatch(
										inspectorActions.document.logSelect(
											groupedTaskData
										)
									);
									if (
										logCode === 'deckLogConfig' ||
										logCode === 'engineLogConfig'
									) {
										const parsedDate = commonUtils
											.getUtcTime(selectedDate)
											.format('yyyy-MM-DD');
										if (logCode === 'engineLogConfig' && groupedTaskData[0]) {

											dispatch(
												inspectorActions.commands.getLogPrintTemplate(
													groupedTaskData[0]?.code,
													inspectorConstants.FEATURE,
													vesselId,
													groupedTaskData[0]?.versionInfo
														?.config,
												)
											);
										}

										// For fetching the associated day logs
										dispatch(
											inspectorActions.commands.getDayLogForAParticularDate(
												parsedDate,
												vesselId,
												intlDateLineRecord,
											)
										);
										dispatch(job.success({}));
									}
									// else reset the associatedDayLog
									else {
										dispatch(
											inspectorActions.document.setAssociatedDayLog(
												{}
											)
										);
									}
								},

								onError(error) {
									dispatch(
										job.error({
											message:
												apiUtils.getResponseStatusMessageForError(
													error
												),
											notification: {},
										})
									);
									dispatch(job.idle({}));
								},
								finally() {
									dispatch(job.idle({}));
								},
							},
						})
					);
				} else {
					dispatch(inspectorActions.document.logSelect({}));
					console.log('no log code or selectedDate provided!');
				}
				break;
			}
			case EInspectorActions.GET_DAY_LOG_PARTICULAR_DATE: {
				next(action);
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				const { vesselId } = action.payload;
				const selectedDate = action.payload?.selectedDate;
				const intlDateLineRecord = action.payload?.intlDateLineRecord;
				let where: any;

				if (selectedDate) {
					where = {
						selectedDate: selectedDate,
						vesselId,
					};

					if (intlDateLineRecord === true) {
						where.intlDateLineRecord = true;
					}
					dispatch(
						apiActions.apiRequest({
							feature: action.type,
							method: 'GET',
							url: `${commonUtils.getAPIBaseUrl()}/api/day-logs`,
							queryParams: {...where},
							preExecute() {
								dispatch(job.active({}));
							},
							postExecute: {
								onSuccess({ data: dayLogData }) {
									if (dayLogData?.[0]) {
										// save the received dayLog data in associatedDayLog
										dispatch(
											inspectorActions.document.setAssociatedDayLog(
												dayLogData[0]
											)
										);
									} else {
										// reset the associatedDayLog
										dispatch(
											inspectorActions.document.setAssociatedDayLog(
												{}
											)
										);
									}
								},
								onError(error) {
									dispatch(
										job.error({
											message:
												apiUtils.getResponseStatusMessageForError(
													error
												),
										})
									);
								},
								finally() {
									dispatch(job.idle({}));
								},
							},
						})
					);
				}

				break;
			}

			case EInspectorActions.GET_INDEX_OF_TASKS: {
				next(action);
				const { vesselId } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				dispatch(
					apiActions.apiRequest({
						feature: action.type,
						method: 'GET',
						url: `${commonUtils.getAPIBaseUrl()}/api/tasks-all`,
						queryParams: {
							vesselId,
						},
						preExecute() {
							dispatch(
								job.active({
									message: 'Loading Index Of Tasks',
								})
							);
						},
						postExecute: {
							onSuccess({ data: indexOfTasks }) {
								setTimeout(() => {
									dispatch(
										inspectorActions.document.setIndexOfTasks(
											indexOfTasks
										)
									);
									dispatch(
										job.success({
											message: 'Loaded Index of Tasks!',
										})
									);
								}, 500);
							},
							onError(error) {
								dispatch(
									job.error({
										message:
											apiUtils.getResponseStatusMessageForError(
												error
											),
										notification: {},
									})
								);
								dispatch(job.idle({}));
							},
						},
					})
				);

				break;
			}
			case EInspectorActions.GET_SEAL_LOGS: {
				next(action);
				const { vesselId } = action.payload;
				const job = jobActions(inspectorConstants.FEATURE, action.type);
				const inspectorStore = inspectorSelectors._getStore(getState());
				let dateRange = inspectorSelectors.getDateRange(inspectorStore);
				if (!dateRange.startDate && !dateRange.endDate) {
					dateRange = {
						startDate: moment.utc().subtract(30, 'days').toDate(),
						endDate: moment.utc().add(1, 'days').toDate(),
					};
					dispatch(
						inspectorActions.document.setDateRange({
							endDate: dateRange.endDate,
							startDate: dateRange.startDate,
						})
					);
				}

				let sealLogsDateRange = {
					startDate: commonUtils.getStartOfDay(
						moment(dateRange.startDate).format('YYYY-MM-DD')
					),
					endDate: commonUtils.getEndOfDay(
						moment(dateRange.endDate).format('YYYY-MM-DD')
					),
				};

				dispatch(
					apiActions.apiRequest<ISealLog[]>({
						feature: action.type,
						method: 'GET',
						url: `${commonUtils.getAPIBaseUrl()}/api/seallogs`,
						queryParams: {
							vesselId: vesselId,
							limit: 1000,
							skip: 0,
							selector: {
								$and: [
									{
										dateReceived: {
											$gte: sealLogsDateRange.startDate,
										},
									},
									{
										dateReceived: {
											$lte: sealLogsDateRange.endDate,
										},
									},
									{
										state: {
											$ne: 'AVAILABLE',
										},
									},
								],
							},
							order: [{
								dateReceived: 'desc',
							}]
						},
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data: sealLogs }) {
								dispatch(
									inspectorActions.document.setSealLogs(
										sealLogs
									)
								);
								dispatch(job.success({}));
							},
							onError(error) {
								dispatch(
									job.error({
										message:
											error?.response?.data?.error
												?.message ??
											'An error has occurred while getting the seal logs',
										notification: {},
									})
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					})
				);

				break;
			}

			case EInspectorActions.GET_APPROPRIATE_MARPOL_RECORDS: {
				next(action);
				const { entry, urlDates, vesselId } = action.payload;
				const inspectorStore = inspectorSelectors._getStore(getState());
				let dateRange = inspectorSelectors.getDateRange(inspectorStore);
				if (!dateRange.startDate && !dateRange.endDate) {
					dateRange = {
						startDate: moment.utc().subtract(30, 'days').toDate(),
						endDate: moment.utc().add(1, 'days').toDate(),
					};
					dispatch(
						inspectorActions.document.setDateRange({
							endDate: dateRange.endDate,
							startDate: dateRange.startDate,
						})
					);
				}

				let marpolDateRange = {
					startDate: commonUtils.getStartOfDay(
						moment(dateRange.startDate).format('YYYY-MM-DD')
					),
					endDate: commonUtils.getEndOfDay(
						moment(dateRange.endDate).format('YYYY-MM-DD')
					),
					state: '',
				};

				if (urlDates?.from && urlDates?.to) {
					let { from, to } = urlDates;
					from = from.toUpperCase();
					to = to.toUpperCase();
					// INFO: need to do proper checking if we are receiving in proper format.
					if (
						isValidUrlDateTimeString(from) &&
						isValidUrlDateTimeString(to)
					) {
						marpolDateRange = {
							startDate: from,
							endDate: to,
							state: '',
						};
					}
				}

				switch (entry.id) {
					case 'ORB1':
						marpolDateRange['state'] = EORB1RecordState.APPROVED;
						dispatch(
							orb1Actions.document.setFilter(marpolDateRange)
						);
						dispatch(
							orb1Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'ORB4':
						marpolDateRange['state'] = EORB4RecordState.APPROVED;
						dispatch(
							orb4Actions.document.setFilter(marpolDateRange)
						);
						dispatch(
							orb4Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'CRB':
						marpolDateRange['state'] = ECRBRecordState.APPROVED;
						dispatch(
							crbActions.document.setFilter(marpolDateRange)
						);
						dispatch(
							crbActions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'GRB1':
						marpolDateRange['state'] = EGarbageRecordState.APPROVED;
						dispatch(
							garbageRecordActions.document.filterSet(marpolDateRange)
						);
						dispatch(
							garbageRecordActions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;

					case 'GRB2':
						marpolDateRange['state'] = EGRB2State.APPROVED;
						dispatch(
							grb2Actions.document.filterSet(marpolDateRange)
						);
						dispatch(
							grb2Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'BFL1':
						marpolDateRange['state'] = EBFL1RecordState.APPROVED;
						dispatch(
							bfl1Actions.document.setFilter(marpolDateRange)
						);
						dispatch(
							bfl1Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'BFL2':
						marpolDateRange['state'] = EBFL2RecordState.APPROVED;
						dispatch(
							bfl2Actions.document.setFilter(marpolDateRange)
						);
						dispatch(
							bfl2Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'ANNEX6':
						marpolDateRange['state'] = EAnnex6RecordState.APPROVED;
						dispatch(
							annex6Actions.document.setFilter(marpolDateRange)
						);
						dispatch(
							annex6Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'BALLAST':
						marpolDateRange['state'] = EBallastRecordState.APPROVED;
						dispatch(
							ballastActions.document.setFilter({
								marpolDateRange,
							})
						);
						dispatch(
							ballastActions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					case 'BALLAST_TANK_OPERATIONS': {
						// No need to setFilter for ballast.
						dispatch(
							ballastActions.commands.tableLogsLoad({
								...marpolDateRange,
								shownRecords: "ALL",
                                sortOrder: 'asc',
								vesselId,
							})
						);
						break;
					}
					case 'ANNEX6V2':
						marpolDateRange['state'] =
							EAnnex6V2RecordState.APPROVED;
						dispatch(
							annex6V2Actions.document.setFilter(marpolDateRange)
						);
						dispatch(
							annex6V2Actions.commands.historyLoad({
								...marpolDateRange,
								sortOrder: 'asc',
								shownRecords: 'ALL',
								vesselId,
							})
						);
						break;
					default:
						break;
				}
				break;
			}

			case EInspectorActions.PUBLIC_PRINT_VIEW_LOAD: {
				next(action);
				//INFO: Handle case for certain url when pdf needs to be generated using backend.
				const priorUrlPart = '/public/print';

				const indexOfPriorUrlPart =
					window.location.href.indexOf(priorUrlPart);
				const endIndexOfPriorUrlPart =
					indexOfPriorUrlPart + priorUrlPart.length;

				const paramsPart = window.location.href?.slice(
					endIndexOfPriorUrlPart
				);
				const params = paramsPart.split('/').filter((p) => p !== '');

				const URL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
				const [entryType, bookId, from, to] = params;

				const isValidFrom = isValidDateTimeFormat(
					URL_DATE_TIME_FORMAT,
					from?.toUpperCase()
				);
				const isValidTo = isValidDateTimeFormat(
					URL_DATE_TIME_FORMAT,
					to?.toUpperCase()
				);

				if (
					params.length === 4 &&
					from &&
					to &&
					isValidFrom &&
					isValidTo
				) {
					// dispatch(
					//     historyActions.push(
					//         action.type,
					//         rootRoutes.children.public.children.print.url(
					//             entryType,
					//             bookId,
					//             from,
					//             to
					//         )
					//     )
					// );
					return;
				}
				dispatch(
				    historyActions.push(
				        action.type,
				        rootRoutes.children.app.children.vessel.url()
				    )
				);

				break;
			}
			default:
				next(action);
		}
	};
};

export default inspectorMiddleware;
